import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import { reducer as formReducer } from 'redux-form';
import thunk from 'redux-thunk';
import { reducer as derivedData } from 'hoc/withPropStateSyncToRedux';

import { reducer as location } from './redux-modules/location';

const appReducer = combineReducers({
  form: formReducer,
  location,
  derivedData,
});

const store = createStore(
  appReducer,
  compose(
    applyMiddleware(thunk),
    window.devToolsExtension ? window.devToolsExtension() : f => f,
  ),
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js